﻿import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Route, Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { trigger, state, style, animate, transition } from '@angular/animations';

import 'rxjs/add/operator/pairwise';
// APP
import { InformationService } from '../../../services/information.service';
import { SharedService } from '../../../services/shared.service';
import { FoucsChangeService } from '../../../services/focuschange.service';
import { HousingFund } from '../../../viewmodel';
import { Animations } from '../../common/animations';

@Component({

    selector: 'affordable-housing',
    templateUrl: './affordable-housing.component.html',
    providers: [InformationService],
    animations: [Animations.flyInOut]
})
export class AffordableHousingComponent implements OnInit {

    animate: string = 'active';
    title: string = 'Affordable Housing';
    projectId: number = 0;
    isEdit: boolean = false; 
    pageError: any = [];
    pageSuccess: any = [];
    submitted: boolean = false;
    ahfForm: FormGroup;
    model: HousingFund;
    showYesMessage: boolean = false; 
    showNoMessage: boolean = false; 
    isEditMood: boolean = true; 
    isAppEditable: boolean = false;

    constructor(private router: Router
        , private activeRoute: ActivatedRoute
        , private formBuilder: FormBuilder
        , private informationService: InformationService
        , private sharedService: SharedService
        , private foucsChangeService: FoucsChangeService) {

        this.model = new HousingFund();
        this.model.ProjectId = this.projectId; 
}

    ngOnInit() {
 
        let ids = this.sharedService.getJsonData("id");
        if (ids != null) {
            if (ids.projectId != null) {
                this.projectId = ids.projectId;
            }
            /*
            if (ids.appStatus == 'Draft') {
                this.isAppEditable = true;
            }
            else {
                this.sharedService.navigateSummary();
            }  */          
        } 
        if (this.projectId <= 0)
            this.sharedService.navigateHome();

        this.ahfForm = this.formBuilder.group({
            Hfo: [null, [Validators.required]] 
        });

        this.informationService.getQuestionByType(this.projectId, 'AHF')
            .subscribe(
            success => {
                if (!success.Success)
                    this.showError(success.StatusMessage);
                else {
                    this.model = success.Result;
                    this.isEdit = this.model.IsValid;

                    if (success.Result.HfoId <= 0)
                        this.isEditMood = false; 

                    if (this.model.ProjectId == 0 && this.projectId == 0)
                        this.showError("Project ID not found!")
                    else if (this.model.ProjectId == 0)
                        this.model.ProjectId = this.projectId;
                }
            },
            error => {
                if (error.status == 401)
                    this.router.navigateByUrl('/login?session=0');

                this.showError(error.ExceptionMessage)
            }) 
    }

   next(button) {
      
        this.submitted = true;
        if (!this.ahfForm.valid) {
            return false;
        }
        this.model.IsValid = this.ahfForm.valid;

        this.informationService.SaveAHF(this.model)
            .subscribe(
            success => {
                if (!success.Success)
                    this.showError(success.StatusMessage);
                else {
                    if (button == 'NEXT') {
                        this.sharedService.navigateSummary();
                    }
                    else if (button = 'LATER')
                        this.sharedService.navigateSummary();
                }
            },
            error => {
                if (error.status == 401)
                    this.router.navigateByUrl('/login?session=0');

                this.showError(error.ExceptionMessage);
            })     
    }

    previous() {
        this.router.navigate(["/information/construction"]);
    }

    home() {
        this.sharedService.navigateHome();
    }
 
    closeError() {
        this.pageError = [];
        this.pageSuccess = [];
    }

    showError(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(this.sharedService.getCustomError(msg));
        this.sharedService.processError(msg);
    }

    showSuccess(msg) {
        this.pageSuccess = []; this.pageError = [];
        this.pageSuccess.push(msg);
        this.sharedService.scroll();
    }

    // show popup only when editing
    changeHousingFund() {        
        if (this.model.Hfo == 'Y' && this.isEditMood) {
            this.showYesMessage = true; 
            this.foucsChangeService.changeFocus(false);           
        }
        else if (this.model.Hfo == 'N' && this.isEditMood) {
            this.showNoMessage = true;  
            this.foucsChangeService.changeFocus(false);        
        }
    }

    selectYes(button) {
        if(button == 'cancel') {
            this.model.Hfo = 'N';
            this.showYesMessage = false; 
            this.foucsChangeService.changeFocus(true);
        }
        else if (button =='ok') {
            this.model.Hfo = 'Y';
            this.showYesMessage = false;
            this.foucsChangeService.changeFocus(true);
        }             
    }

    selectNo(button) {
        if (button == 'cancel') {
            this.model.Hfo = 'Y';
            this.showNoMessage = false;
            this.foucsChangeService.changeFocus(true);
        }
        else if (button =='ok') {
            this.model.Hfo = 'N';
            this.showNoMessage = false;
            this.foucsChangeService.changeFocus(true);
        }
    }

}



